import {Base} from "@/api/Base"

export class ConnectorStopTranscation extends Base {
    path = "connector/stopTranscation"
}